<template>
  <h2>跳转中</h2>
</template>

<script>
import pingpp from 'pingpp-js'
import { chargeOrder } from '../../../api'
export default {
  name: 'alipayRedirect',
  methods: {
    pay () {
      chargeOrder({
        order_no: this.order_no,
        channel: this.channel
      }).then(res => {
        if (res.status === 200) {
          this.success(res.data)
        } else {
          this.fail(res.status)
          console.log(res)
        }
      })
    },
    success (res) {
      if (res.code === 1) {
        let data = res.data
        console.log(data)
        pingpp.createPayment(data, function (result, err) {
          if (result === 'success') {
          } else {
            window.alert(result + ' ' + err.msg + ' ' + err.extra)
          }
        })
      } else {
        window.alert(res.error)
        window.opener = null
        window.open('', '_self')
        window.location.href = 'about:blank'
        window.close()
      }
    },
    fail (status) {
      window.alert(status)
    }
  },
  mounted () {
    this.pay()
  },
  computed: {
    order_no () {
      return this.$route.params.order_no
    },
    channel () {
      return this.$route.params.channel
    }
  }
}
</script>

<style scoped>
  h2 {
    text-align: center;
    margin-top: 15%;
    font-family: Microsoft YaHei;
    color: #979dac;
  }
</style>
